import { render, staticRenderFns } from "./distributionEmployees.vue?vue&type=template&id=72764fb1&scoped=true&"
import script from "./distributionEmployees.vue?vue&type=script&lang=js&"
export * from "./distributionEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72764fb1",
  null
  
)

component.options.__file = "distributionEmployees.vue"
export default component.exports